import React, { useState } from "react";
import { resubscribe } from "../api";
import { setCheckoutFlow } from "../utils/analytics";
import PlanPicker from "./PlanPicker";

/**
 * Choose a plan and go to Stripe. The one place a card is ever asked for.
 *
 * Used mid-trial (the ending banner, the account menu) so someone who has
 * decided early can pay without waiting to be locked out. The backend carries
 * whatever trial days are left into the Checkout, so subscribing early never
 * costs them the free time they had.
 */
export default function UpgradePanel({ note, compact = false }) {
  const [plan, setPlan] = useState("monthly");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const go = async () => {
    setError(null);
    setLoading(true);
    try {
      setCheckoutFlow("resubscribe");
      const { url } = await resubscribe(plan);
      window.location.assign(url);
    } catch (err) {
      setError(err.message || "Could not start checkout.");
      setLoading(false);
    }
  };

  return (
    <div className={compact ? "" : "mt-2"}>
      <PlanPicker plan={plan} onChange={setPlan} className="mb-3" />
      {error && (
        <p className="text-xs text-rose-700 bg-rose-50 border border-rose-200 rounded-lg px-3 py-2 mb-2">
          {error}
        </p>
      )}
      <button
        onClick={go}
        disabled={loading}
        className="w-full px-4 py-2.5 rounded-xl bg-gold-400 text-ink-900 hover:brightness-105 text-sm font-semibold transition-[filter] disabled:opacity-60"
      >
        {loading ? "Starting checkout…" : "Subscribe"}
      </button>
      {note && <p className="mt-2 text-xs text-slate-500">{note}</p>}
    </div>
  );
}
